var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"inner-url-redirect"},[(_vm.loading)?_c('p',[_vm._v("Загрузка...")]):_vm._e(),(_vm.error)?_c('p',[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }